







import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import Dialog from '@/components/dialog.vue';
import EditAllowed from './eidt-allowed.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
import { dpt, grp } from '@/unite/role';
@Component({
  components: { SearchPaginationTable, Dialog, EditAllowed }
})
export default class RunningwaterDetails extends Vue {
  mounted() {
    this.getDpt();
  }
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  optionTitle: string = '';
  visible: boolean = false;
  visibleEdit: boolean = false;
  isDpt: boolean = dpt();
  dptList: object[] = [];
  grpList: object[] = [];
  isGrp: boolean = grp();
  modifyForm: any;
  sendData: any;
  rules: any[] = [];
  pageData: any = {
    url: '/back/v1/cg/list',
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      page_num: 10,
      page_index: 1
    }, // 传后端数据
    searchData: [],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '添加分组',
        methods: 'add',
        type: 'success',
        loading: false
      },
      {
        name: '导出分组',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID',
        //   width: 80
        // },
        {
          prop: 'name',
          label: '名称'
        },
        {
          prop: 'dpt_name',
          label: '部门'
        },
        {
          prop: 'subs',
          label: '订阅关系',
          type: 'sub'
        },
        {
          prop: 'code',
          label: '编码'
        },
        {
          prop: 'modify_user',
          label: '上次修改人',
          width: 150
        },
        {
          prop: 'token',
          label: 'Token'
        }
      ],
      expand: [],
      optionWidth: 360,
      option: [
        {
          name: '修改',
          methods: 'modify',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '绑定Potato',
          methods: 'bindP',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '绑定Telegram',
          methods: 'bindT',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '重置token',
          methods: 'reset',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '修改关系',
          methods: 'allowed',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '删除',
          methods: 'delete',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  dialogAddData: any = {
    modifyForm: {
      url: '/back/v1/cg/create',
      width: '35%',
      form: {
        name: '',
        dpt_id: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'name',
          name: '分组名称'
        }
      ],
      select: {
        dpt_id: []
      }
    },
    rules: {
      name: [
        {
          required: true,
          message: '请输入分组名称',
          trigger: 'blur'
        }
      ]
    }
  };
  dialogModifyData: any = {
    modifyForm: {
      url: '/back/v1/cg/modify',
      width: '35%',
      form: {
        name: '',
        id: 0
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'id',
          name: 'ID',
          disabled: true
        },
        {
          type: 'input',
          model: 'name',
          name: '分组名称'
        }
      ],
      select: {
        role: []
      }
    },
    rules: {
      name: [
        {
          required: true,
          message: '请输入分组名称',
          trigger: 'blur'
        }
      ]
    }
  };
  private handleClick(methods: string, row: any) {
    this.sendData = row;
    if (methods === 'modify') {
      this.optionTitle = '修改分组';
      this.dialogModifyData.modifyForm.form.id = row.id;
      this.dialogModifyData.modifyForm.form.name = row.name;
      this.visible = true;
      this.modifyForm = this.dialogModifyData.modifyForm;
      this.rules = this.dialogModifyData.rules;
    } else if (methods === 'delete') {
      this.publicApi(
        `/back/v1/cg/delete?id=${row.id}`,
        `是否确认删除${row.name}`,
        {}
      );
    } else if (methods === 'reset') {
      this.publicApi(
        `/back/v1/cg/reset?id=${row.id}`,
        `是否确认重置${row.name}Token`,
        {}
      );
    } else if (methods === 'bindP' || methods === 'bindT') {
      get(
        `/back/v1/cg/bind?id=${row.id}&type=${methods === 'bindP' ? 1 : 2}`,
        {}
      ).then(d => {
        this.$alert(
          // @ts-ignore
          `步骤一：${d.Content.step1},\n\n步骤二：${d.Content.step2}`,
          '绑定步骤',
          {
            confirmButtonText: '确定'
          }
        );
      });
    } else if (methods === 'allowed') {
      this.visibleEdit = true;
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.optionTitle = '添加分组';
      this.visible = true;
      this.modifyForm = this.dialogAddData.modifyForm;
      this.rules = this.dialogAddData.rules;
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
    this.visibleEdit = false;
  }
  private getDpt() {
    if (this.isDpt) {
      get('/back/v1/dpt/list?page_index=1&page_num=10000', {}).then(d => {
        // @ts-ignore
        d.Content.list.forEach(item => {
          this.dptList = [
            ...this.dptList,
            { label: item.name, value: item.id }
          ];
        });
        this.pageData.searchData.push({
          type: 'select', // text框
          model: 'dpt_id', // 字段
          tip: '部门',
          data: this.dptList
        });
        this.dialogAddData.modifyForm.data[1] = {
          type: 'select', // text框
          model: 'dpt_id', // 字段
          name: '部门'
        };
        this.dialogAddData.modifyForm.select.dpt_id = this.dptList;
      });
    }
  }
  // 公共方法
  publicApi(url: string, msg: string, Infodata: any) {
    this.$confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        get(url, Infodata)
          .then(d => {
            // @ts-ignore
            this.$refs.table.getData();
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          })
          .catch(e => {
            // @ts-ignore
            this.$refs.table.getData();
          });
      })
      .catch(() => {
        // @ts-ignore
        this.$refs.table.getData();
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
  }
}
